import { CollapseItem } from 'element-ui'

const YCollapseItem = CollapseItem
YCollapseItem.$depends = [CollapseItem]
YCollapseItem.$name = 'y-collapse-item'
YCollapseItem._name = 'collapse-item 折叠面板选项'

export default YCollapseItem
